const GalleryItem = (props) =>{
    return( 
    <li>
        <img src={props.url} className="flex-item imgborder" alt={props.description} ></img>
    </li>
    )
}

export default GalleryItem;